// export
// // --- พิกัดทางพิเศษฉลองรัช (แยกช่วงตามตำแหน่งจริง) ---
// const CHALONG_RAT_MAIN_PATH = [
//   // 1. ช่วงอาจณรงค์ - สุขุมวิท 50 (เริ่มต้นเชื่อมทางด่วนขั้นที่ 1)
//   [13.7011, 100.5913],
//   [13.7025, 100.5925],
//   [13.7042, 100.5938],
//   [13.7055, 100.5945],
//   [13.7075, 100.5962],
//   [13.71, 100.598],
//   [13.7125, 100.5995],
//   [13.7145, 100.6008],

//   // 2. ช่วงพระโขนง - คลองตัน (ข้ามสุขุมวิท 71)
//   [13.7161, 100.6014],
//   [13.718, 100.6025],
//   [13.7209, 100.6038],
//   [13.7224, 100.6046],
//   [13.7244, 100.605],
//   [13.7275, 100.6047],
//   [13.73, 100.6044],
//   [13.733, 100.6043],

//   // 3. ช่วงพัฒนาการ - ทางแยกพระราม 9
//   [13.736, 100.6044],
//   [13.739, 100.6046],
//   [13.7415, 100.6048],
//   [13.744, 100.605],
//   [13.7465, 100.6052],
//   [13.749, 100.6047],
//   [13.7505, 100.6025],
//   [13.7525, 100.5998],

//   // 4. ช่วง S-Curve พระราม 9 (ละเอียดพิเศษ - จุดเชื่อมต่อทางด่วนศรีรัช)
//   [13.754, 100.5977],
//   [13.7548, 100.597],
//   [13.7555, 100.5964],
//   [13.7562, 100.5959],
//   [13.7568, 100.5956],
//   [13.757, 100.5955],
//   [13.758, 100.5955],
//   [13.759, 100.5958],
//   [13.7595, 100.5962],
//   [13.76, 100.5965],
//   [13.7608, 100.5969],
//   [13.7612, 100.5971],
//   [13.762, 100.5975],
//   [13.7625, 100.5976],
//   [13.764, 100.5989],
//   [13.765, 100.5999],

//   // 5. ช่วงประชาอุทิศ - ประดิษฐ์มนูธรรม (เลียบด่วน ช่วงทาวน์อินทาวน์)
//   [13.7665, 100.601],
//   [13.768, 100.6025], //
//   [13.769, 100.6035],
//   [13.7715, 100.6055],
//   [13.772, 100.6057],
//   [13.775, 100.6069],
//   [13.778, 100.6069],
//   [13.7785, 100.6070],

//   // 6. ช่วงแยกลาดพร้าว - CDC - Central Eastville
//   [13.781, 100.607],
//   [13.782, 100.6077],
//   [13.7835, 100.6083],
//   [13.785, 100.6085],
//   [13.786, 100.6092],
//   [13.788, 100.6095],
//   [13.7885, 100.6098],
//   [13.7915, 100.6105],
//   [13.793, 100.6113],
//   [13.7945, 100.612],
//   [13.795, 100.6122],
//   [13.797, 100.613],
//   [13.798, 100.6135],
//   [13.7995, 100.6142],
//   [13.801, 100.615],
//   [13.802, 100.6157],

//   // 7. ช่วงเกษตรนวมินทร์ - รามอินทรา (กม. 5)
//   [13.804, 100.6165],
//   [13.8045, 100.6168],
//   [13.807, 100.618],
//   [13.808, 100.6185],
//   [13.81, 100.6195],
//   [13.8115, 100.62],
//   [13.813, 100.621],
//   [13.815, 100.622],
//   [13.816, 100.6225],
//   [13.8185, 100.6235],
//   [13.819, 100.624],
//   [13.821, 100.625],
//   [13.822, 100.6255],
//   [13.8235, 100.6262],
//   [13.826, 100.6275],
//   [13.8285, 100.6288],

//   // 8. ช่วงวัชรพล - สุขาภิบาล 5
//   [13.83, 100.6295],
//   [13.831, 100.63],
//   [13.834, 100.6315],
//   [13.8345, 100.632],
//   [13.838, 100.634],
//   [13.842, 100.636],
//   [13.8455, 100.6385],
//   [13.8485, 100.64],

//   // 9. ช่วงสายไหม - ด่านจตุโชติ
//   [13.852, 100.6415],
//   [13.856, 100.6432],
//   [13.86, 100.6442],
//   [13.865, 100.6453],
//   [13.87, 100.6462],
//   [13.875, 100.6475],
//   [13.88, 100.6485],
//   [13.884, 100.6498],

//   // 10. ช่วงเชื่อมต่อวงแหวนกาญจนาภิเษก (จุดสิ้นสุดทางเหนือ)
//   [13.8875, 100.6525],
//   [13.8895, 100.655],
//   [13.8915, 100.6575],
//   [13.8935, 100.661],
//   [13.8955, 100.666],
//   [13.8962, 100.671],
//   [13.8968, 100.676],
//   [13.8972, 100.682],
//   [13.8975, 100.6875],
//   [13.8978, 100.6905],
//   [13.898, 100.693],
// ];

/**
 * ข้อมูลพิกัดทางพิเศษฉลองรัช (รามอินทรา-อาจณรงค์)
 * ความละเอียดสูง พร้อมจุดโค้งสำคัญ
 */

export const CHALONG_RAT_MAIN_PATH = [
  // 1. ช่วงอาจณรงค์ - สุขุมวิท 50 (เริ่มต้นเชื่อมทางด่วนขั้นที่ 1)
  [13.7011, 100.5913],
  [13.7025, 100.5925],
  [13.7042, 100.5938],
  [13.7055, 100.5945],
  [13.7075, 100.5962],
  [13.71, 100.598],
  [13.7125, 100.5995],
  [13.7145, 100.6008],

  // 2. ช่วงพระโขนง - คลองตัน (ข้ามสุขุมวิท 71)
  [13.7161, 100.6014],
  [13.718, 100.6025],
  [13.7209, 100.6038],
  [13.7224, 100.6046],
  [13.7244, 100.605],
  [13.7275, 100.6047],
  [13.73, 100.6044],
  [13.733, 100.6043],

  // 3. ช่วงพัฒนาการ - ทางแยกพระราม 9
  [13.736, 100.6044],
  [13.739, 100.6046],
  [13.7415, 100.6048],
  [13.744, 100.605],
  [13.7465, 100.6052],
  [13.749, 100.6047],
  [13.7505, 100.6025],
  [13.7525, 100.5998],

  // 4. ช่วง S-Curve พระราม 9 (ละเอียดพิเศษ - จุดเชื่อมต่อทางด่วนศรีรัช)
  [13.754, 100.5977],
  [13.7548, 100.597],
  [13.7555, 100.5964],
  [13.7562, 100.5959],
  [13.7568, 100.5956],
  [13.757, 100.5955],
  [13.758, 100.5955],
  [13.759, 100.5958],
  [13.7595, 100.5962],
  [13.76, 100.5965],
  [13.7608, 100.5969],
  [13.7612, 100.5971],
  [13.762, 100.5975],
  [13.7625, 100.5976],
  [13.764, 100.5989],
  [13.765, 100.5999],

  // 5. ช่วงประชาอุทิศ - ประดิษฐ์มนูธรรม (เพิ่มจุดโค้งศรีวรา Town in Town)
  [13.7665, 100.601],
  [13.768, 100.6025],
  [13.769, 100.6035],
  [13.7715, 100.6055],
  [13.772, 100.6057],
  [13.775, 100.6069],
  [13.778, 100.6069],
  [13.7785, 100.607],

  
  // 6. ช่วงแยกลาดพร้าว - CDC - Central Eastville
  [13.781, 100.607],
  [13.782, 100.6077],
  [13.7835, 100.6083],
  [13.785, 100.6085],
  [13.786, 100.6092],
  [13.788, 100.6095],
  [13.7885, 100.6098],
  [13.7915, 100.6105],
  [13.793, 100.6113],
  [13.7945, 100.612],
  [13.795, 100.6122],
  [13.797, 100.613],
  [13.798, 100.6135],
  [13.7995, 100.6142],
  [13.801, 100.615],
  [13.802, 100.6157],

  // 7. ช่วงเกษตรนวมินทร์ - รามอินทรา (กม. 5)
  [13.804, 100.6165],
  [13.8045, 100.6168],
  [13.807, 100.618],
  [13.808, 100.6185],
  [13.81, 100.6195],
  [13.8115, 100.62],
  [13.813, 100.621],
  [13.815, 100.622],
  [13.816, 100.6225],
  [13.8185, 100.6235],
  [13.819, 100.624],
  [13.821, 100.625],
  [13.822, 100.6255],
  [13.8235, 100.6262],
  [13.826, 100.6275],
  [13.8285, 100.6288],

  // 8. ช่วงวัชรพล - สุขาภิบาล 5
  [13.83, 100.6295],
  [13.831, 100.63],
  [13.834, 100.6315],
  [13.8345, 100.632],
  [13.838, 100.634],
  [13.842, 100.636],
  [13.8455, 100.6385],
  [13.8485, 100.64],

  // 9. ช่วงสายไหม - ด่านจตุโชติ
  [13.852, 100.6415],
  [13.856, 100.6432],
  [13.86, 100.6442],
  [13.865, 100.6453],
  [13.87, 100.6462],
  [13.875, 100.6475],
  [13.88, 100.6485],
  [13.884, 100.6498],

  // 10. ช่วงเชื่อมต่อวงแหวนกาญจนาภิเษก (จุดสิ้นสุดทางเหนือ)
  [13.8875, 100.6525],
  [13.8895, 100.655],
  [13.8915, 100.6575],
  [13.8935, 100.661],
  [13.8955, 100.666],
  [13.8962, 100.671],
  [13.8968, 100.676],
  [13.8972, 100.682],
  [13.8975, 100.6875],
  [13.8978, 100.6905],
  [13.898, 100.693], // จตุโชติ (S5)
];
